var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B4B4B4",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.25.85a.85.85 0 0 0-.85.85v11.9c0 .468.38.85.85.85H18.7a.85.85 0 0 0 .85-.85V1.7a.85.85 0 0 0-.85-.85H4.25zM18.7 15.3H4.25c-.938 0-1.7-.762-1.7-1.7V1.7c0-.938.762-1.7 1.7-1.7H18.7c.938 0 1.7.762 1.7 1.7v11.9c0 .938-.762 1.7-1.7 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.475 8.925a.426.426 0 0 1-.292-.116l-8.075-7.65A.425.425 0 0 1 3.692.54l7.783 7.373L19.258.541a.425.425 0 0 1 .584.618l-8.075 7.65a.426.426 0 0 1-.292.116M15.725 17.869H1.275A1.277 1.277 0 0 1 0 16.594v-11.9c0-.703.572-1.275 1.275-1.275h1.7a.425.425 0 0 1 0 .85h-1.7a.426.426 0 0 0-.425.425v11.9c0 .234.191.425.425.425h14.45c.234 0 .425-.19.425-.425v-1.7a.425.425 0 0 1 .85 0v1.7c0 .703-.572 1.275-1.275 1.275"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.0737a5d3.svg";
export { ForwardRef as ReactComponent };